"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Heart } from "lucide-react"
import "../styles/footer.css"
import logo from "../assets/logo.png"
import pagamentos from "../assets/footer.webp"

function Footer() {
  const [year, setYear] = useState(new Date().getFullYear())

  // Atualiza o ano automaticamente
  useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <motion.div
            className="footer-logo"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img src={logo || "/placeholder.svg"} alt="Logo Ticket do Vaqueiro" />
            <p className="footer-slogan">A melhor plataforma para vaquejadas do Brasil</p>
            <div className="footer-social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </motion.div>

          <motion.div
            className="footer-menu"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3>MENU</h3>
            <ul>
              <li>
                <a href="/quem-somos">Quem Somos</a>
              </li>
              <li>
                <a href="/vaquejadas">Vaquejadas</a>
              </li>
              <li>
                <a href="/como-contratar">Como Contratar?</a>
              </li>
              <li>
                <a href="#">Fale Conosco</a>
              </li>
            </ul>
          </motion.div>

          <motion.div
            className="politicas-menu"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3>POLÍTICAS</h3>
            <ul>
              <li>
                <a href="/politica-cancelamento">Política de Cancelamento</a>
              </li>
              <li>
                <a href="/politica-privacidade">Política de Privacidade</a>
              </li>
              <li>
                <a href="#">Termos de Uso</a>
              </li>
              <li>
                <a href="#">Central de Ajuda</a>
              </li>
            </ul>
          </motion.div>

          <motion.div
            className="footer-contact"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h3>CONTATO</h3>
            <div className="contact-item">
              <Mail size={16} />
              <span>ticketdovaqueiro@gmail.com</span>
            </div>
            <div className="contact-item">
              <Phone size={16} />
              <span>(83) 99174-0119</span>
            </div>
            <div className="contact-item">
              <MapPin size={16} />
              <span>João Pessoa, PB</span>
            </div>
          </motion.div>
        </div>


        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© {year} - Ticket do Vaqueiro - Todos os direitos reservados</p>
          <p>
            Desenvolvido por{" "}
            <a
              href="https://wa.me/5513991503946"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#00e676", textDecoration: "underline" }}
            >
              TG SOLUÇÕES
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
